module.exports = "<page-layout page=\"traffic\" title=\"{{vm.activeSection.title}}\" header-config=\"vm.headerConfig\" current-region = 'vm.currentRegion'>\n\n    <div class=\"ng-scope\" style=\"height: 100%;display: flex;align-items: center;justify-content: center;opacity: 0.2;color: #e1f0ff;\">\n        <i class=\"fa fa-cogs\" style=\"font-size: 14vw;\"></i>\n    </div>\n\n</page-layout>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/traffic/traffic.html
 ** module id = 65
 ** module chunks = 0
 **/